import { useEffect, useState } from "react";
import useAxios from "../../../utils/useAxios";
import { PageableDTO } from "../../../types/pageable";
import { URL } from "../../../libraries/http/url";
import { Predicates } from "../../../libraries/predicates/predicates";
import { AxiosInstance } from "axios";
import { MasterArtworkCollectionState } from "../../../states/meta-artwork/collections/data.type";

type SearchParams = {
  search?: string;
  id?:string | number;
};

type CollectionResponse =
  | PageableDTO<MasterArtworkCollectionState[]>
  | MasterArtworkCollectionState[];

export const fetchCollection = async ({
  search,
  id,
  axios,
}: SearchParams & { axios: AxiosInstance }) => {
  try {
    const searchParams = URL.createSearchParams({
      search,
      limit: 50,
    });

    const response = await axios.get<CollectionResponse>(
      `/artwork-master/collections/?${searchParams.toString()}`,
    );

    return Predicates.parsePageableReponseToType(response);
  } catch (err) {
    console.error(err);
  }
  return [];
};

export default function useArtworkCollection({ search, id }: SearchParams) {
  const axios = useAxios();
  const [data, setData] = useState<MasterArtworkCollectionState[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      const response = await fetchCollection({
        search,
        id,
        axios,
      });

      setData(response);
      setIsLoading(false);
    };

    getData();
  }, [search]);

  return { data, isLoading };
}
